import React from 'react';

const DrivingCalculator = ({merchantCode}) => {
    return (
        <div className="py-5 bg-secondary driving-calculator" id="DrivingCalculator" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "left" }}>
            <div className="container">
                <div className="center">
                    <div className="center shadow-lg flight-calculator-height">
                        {<iframe frameBorder="0" className="w-100 flight-calculator-height bg-white" src={`${process.env.MY_CC_URL}/driving-calculator?merchantCode=${merchantCode}`}></iframe>}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default DrivingCalculator;